import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH, SYMBOL_HEIGHT, SYMBOL_WIDTH, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import { ParallelTask, Task } from "../../core/utils/ParallelTask";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameEvents } from "../../gameClientEvents/GameEvents";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { reelSpinEmitter } from "../../reels/ReelInit";


export class HighlightFrames extends DisplayObject {

    constructor(config: IDisplayObject) {
        super(config);
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
        this.init();
        this.subscribeToEvents();
    }

    public init() {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            for (let j = 0; j < SYMBOLS_PER_REEL + 1; j++) {
                this.createWinFrame(i, j);
            }
        }
    }

    public override destroy(options?: boolean | undefined): void {
        this.unSubscribeToEvents();
        super.destroy(options);
    }

    public highlight(col: number, row: number) {
        const frame = this.getChildByLabel("frame_" + col + "_" + row) as Spine;
        if (frame) {
            frame.visible = true;
            frame.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            sound.play(SoundConstants.SYMBOL_HIGHLIGHTED, {
                volume: 0.8,
            });
            frame.state.setAnimation(0, "in", false).listener = {
                complete: () => {
                    frame.state.setAnimation(0, "loop", true);
                    frame.state.clearListeners();
                }

            }
        }
    }

    public hideAllFrameFS() {
        this.hideframes();
    }

    private subscribeToEvents() {
        // reelSpinEmitter.on("winsStarted", this.showWinFrames, this);
        reelSpinEmitter.on("resetWins", this.hideframes, this);
        GameEvents.emitter.on(EventConstants.HIDE_FRAMES, this.hideAllFrameFS, this);
    }

    private unSubscribeToEvents() {
        // reelSpinEmitter.off("winsStarted", this.showWinFrames, this);
        reelSpinEmitter.off("resetWins", this.hideframes, this);
        GameEvents.emitter.off(EventConstants.HIDE_FRAMES, this.hideAllFrameFS, this);
    }

    private createWinFrame(reelIndex: number, rowIndex: number): void {
        const highlightFrame = Spine.from({
            skeleton: "frameSkel",
            atlas: "frameAtlas"
        });


        if (rowIndex >= SYMBOLS_PER_REEL) {
            return;
        }
        const x =
            REEL_FRAME +
            Math.round(SYMBOL_WIDTH / 2) +
            reelIndex * (REEL_WIDTH + REEL_DIVIDER);

        const y =
            REEL_FRAME +
            Math.round(SYMBOL_HEIGHT / 2) +
            rowIndex * SYMBOL_HEIGHT;

        highlightFrame.x = x;
        highlightFrame.y = y;
        highlightFrame.label = `frame_${reelIndex}_${rowIndex}`
        highlightFrame.visible = false;;
        this.addChild(highlightFrame);
    }

    //@ts-ignore
    private async showWinFrames() {
        let winObjects: number[][] = []; // spinData.respins[RespinIndex.value].featureData?.highlightPositions;

        let arr: Task<any>[] = [];

        if (!winObjects) return Promise.resolve();

        winObjects.forEach((winObject) => {
            if (!winObject) return;

            const reelNum: number = winObject[0];
            const posNum: number = winObject[1];
            const frame = this.getChildByLabel("frame_" + reelNum + "_" + posNum) as Spine;

            if (frame) {
                let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

                arr.push(() => new Promise<void>(() => {
                    frame.visible = true;
                    frame.state.timeScale = timeScale;
                    frame.state.setAnimation(0, "in", false).listener = {
                        complete: () => {
                            frame.state.setAnimation(0, "loop", true);
                            frame.state.clearListeners();
                        }

                    }
                    frame.state.apply(frame.skeleton);
                }));
            }
        });

        if (arr.length === 0) return Promise.resolve();
        const masterTask = new ParallelTask(arr);
        return await masterTask.execute({ stagger: 50 });
    }

    //@ts-ignore
    private hideframes() {
        for (const frame of this.children) {
            if (!frame) continue;
            (frame as Spine).state.setAnimation(0, "out", false).listener = {
                complete: () => {
                    (frame as Spine).visible = false;
                }
            }
        }
    }
}
